import * as React from "react";
const SvgFiRrPanFrying = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pan-frying_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-5.113-5.113A10.45 10.45 0 0 0 21 10.5C21 4.71 16.29 0 10.5 0S0 4.71 0 10.5 4.71 21 10.5 21c2.536 0 4.864-.904 6.68-2.406l5.113 5.113a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M2 10.5C2 5.813 5.813 2 10.5 2S19 5.813 19 10.5 15.187 19 10.5 19 2 15.187 2 10.5m9-.5a2 2 0 1 1-3.999.001A2 2 0 0 1 11 10m3.028-3.283c-1.221-2.048-3.275-3.032-5.492-2.629C5.908 4.564 4 6.88 4 9.594V10c0 3.86 3.14 7 7 7 2.151 0 4.031-1.522 4.372-3.542.01-.06.047-.1.078-.124.956-.738 1.55-1.92 1.55-3.085 0-1.661-1.222-3.111-2.972-3.532m.2 5.034a2.2 2.2 0 0 0-.829 1.375C13.222 14.177 12.168 15 11 15c-2.757 0-5-2.243-5-5v-.406C6 7.847 7.216 6.36 8.893 6.056q.321-.057.611-.056c1.588 0 2.482 1.195 2.815 1.757.268.451.719.78 1.24.905.694.166 1.441.733 1.441 1.588 0 .55-.303 1.14-.772 1.501"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pan-frying_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPanFrying;
